import { render, staticRenderFns } from "./LabeledInput.vue?vue&type=template&id=5fc2519b"
import script from "./LabeledInput.vue?vue&type=script&lang=js"
export * from "./LabeledInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports